import { useCallback, useEffect, useRef, useState } from "react";
import { fetchPhotos, type PublicPhoto } from "../api/photos";

export function usePhotoFeed(pollIntervalSeconds: number) {
  const [photos, setPhotos] = useState<PublicPhoto[]>([]);
  const [loaded, setLoaded] = useState(false);
  const cancelledRef = useRef(false);

  const refresh = useCallback(async () => {
    try {
      const latest = await fetchPhotos();
      if (cancelledRef.current) return;
      setPhotos(latest);
      setLoaded(true);
    } catch {
      // Transient network errors are expected on a venue's flaky wifi; the
      // next poll tick (or manual refresh) will retry.
    }
  }, []);

  useEffect(() => {
    cancelledRef.current = false;
    void refresh();
    const interval = setInterval(refresh, pollIntervalSeconds * 1000);
    return () => {
      cancelledRef.current = true;
      clearInterval(interval);
    };
  }, [pollIntervalSeconds, refresh]);

  return { photos, loaded, refresh };
}
